// extracted by mini-css-extract-plugin
export default {"authorContainer":"bT_hl","authorName":"bT_hm","authorDataContainer":"bT_hn","prefix":"bT_hp","authorTitle":"bT_hq","reviewerTitle":"bT_hr"};